var map = {
	"./Pattern01.png": "970e",
	"./Pattern02.png": "7d68",
	"./Pattern03.png": "b9cc",
	"./Pattern04.png": "3c43",
	"./Pattern05.png": "8bf7",
	"./Pattern06.png": "ed9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a14";